import { render, staticRenderFns } from "./login-again.vue?vue&type=template&id=97216118&"
import script from "./login-again.vue?vue&type=script&lang=js&"
export * from "./login-again.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports